import styled from '@emotion/styled'

import {buttonStyles} from './AnchorButton'

export default styled.button`
  cursor: pointer;
  line-height: 1.45;
  ${buttonStyles}
`